(() => {
  const styleId = 'evig-flora-studio-form-style';
  const styles = `
    [class*="_teaserContainer_"] {
      min-height: 5.8rem !important;
      padding: 1.4rem 1.8rem !important;
      border: 1px solid rgba(20, 20, 20, .18) !important;
      border-radius: 2px !important;
      background: #fff !important;
      box-shadow: 0 8px 26px rgba(0, 0, 0, .08) !important;
    }
    [class*="_teaserHeading_"] {
      font-size: 1.4rem !important;
      font-weight: 500 !important;
      letter-spacing: .02em !important;
    }
    [class*="_teaserContainer_"] button,
    [class*="_teaserContainer_"] [aria-label*="Close"] {
      border-radius: 0 !important;
      background: transparent !important;
    }
    [class*="_overlay_"] {
      border-radius: 3px !important;
    }
    [class*="_formContainer_"] {
      overflow: hidden !important;
      border: 1px solid rgba(20, 20, 20, .18) !important;
      border-radius: 3px !important;
      box-shadow: 0 18px 60px rgba(0, 0, 0, .18) !important;
    }
    [class*="_gridItem_"] {
      border-radius: 0 !important;
    }
    [class*="_formHeader_"] {
      margin-bottom: 1.6rem !important;
    }
    [class*="_textHeading_"] {
      font-weight: 500 !important;
      letter-spacing: 0 !important;
    }
    [class*="_formFieldset_"] input {
      border: 0 !important;
      border-bottom: 1px solid rgba(20, 20, 20, .28) !important;
      border-radius: 0 !important;
      box-shadow: none !important;
    }
    [class*="_formFieldset_"] button[type="submit"] {
      border-radius: 0 !important;
      box-shadow: none !important;
    }
    @media (max-width: 749px) {
      [class*="_teaserContainer_"] { min-height: 5.2rem !important; padding: 1.2rem 1.5rem !important; }
      [class*="_formContainer_"] { border-radius: 0 !important; }
    }
  `;

  const apply = () => {
    document.querySelectorAll('shopify-forms-embed').forEach((host) => {
      const root = host.shadowRoot;
      if (!root || root.getElementById(styleId)) return;
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = styles;
      root.append(style);
    });
  };

  apply();
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();
